import cnpj from './cnpj';
import cpf from './cpf';

const FORMATTERS = {
  cnpj,
  cpf,
};

function parse(value) {
  if (typeof value === 'string') {
    let type = null;
    if (value.length === 11) {
      type = 'cpf';
    } else if (value.length === 14) {
      type = 'cnpj';
    }

    return { type, value };
  }

  return value;
}

export default (obj) => {
  if (!obj) return '';

  const { type, value } = parse(obj);

  const formatter = type ? FORMATTERS[type] : null;
  return formatter ? formatter(value) : value;
};
